import { clampNumber } from "./clamp-number";

function getClampedVolume(nextVolume: number): number | undefined {
  if (!Number.isFinite(nextVolume)) {
    return undefined;
  }

  return clampNumber(nextVolume, 0, 1);
}

export { getClampedVolume };
